import {doc} from '../docs.js';
import SampleBank from '../../custom/SampleBank.js';

doc(
    "sampleBank",
    {
    },
    "Store samples and send them to tracks",
    () => 0,
    {
        inlets: 0
    });

export const sampleBank = (object) => {
    object.effect = new SampleBank(object);
    return () => {
    };
};
